var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoItalicIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95757 3.0625C8.4852 3.0625 8.74901 3.4216 8.74901 3.83307C8.74901 4.34691 8.29068 4.82217 7.69415 4.82217C7.19448 4.82217 6.90311 4.52686 6.91689 4.03861C6.91689 3.62793 7.26378 3.0625 7.95757 3.0625ZM6.33414 10.9375C5.91755 10.9375 5.6124 10.6808 5.90377 9.54993L6.38178 7.54495C6.46486 7.22444 6.47865 7.09568 6.38178 7.09568C6.25696 7.09568 5.71674 7.31697 5.39662 7.5355L5.18872 7.189C6.20145 6.32826 7.36655 5.82387 7.86661 5.82387C8.28281 5.82387 8.35211 6.32511 8.14421 7.09568L7.5965 9.20303C7.49964 9.57513 7.54098 9.70349 7.63824 9.70349C7.76306 9.70349 8.17256 9.54914 8.57497 9.22823L8.81122 9.54874C7.82606 10.5516 6.74994 10.9375 6.33414 10.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoItalicIcon);
export default __webpack_public_path__ + "static/media/InfoItalicIcon.c7a496362a6636564499490ea43477a0.svg";
export { ForwardRef as ReactComponent };